import { TextInput as TextInputMantine } from '@mantine/core'
import styled from 'styled-components'

export const Input = styled(TextInputMantine)`
  .mantine-Input-input {
    border: none;
    color: ${({ theme }) => theme.cor9};
    background-color: ${({ theme }) => theme.cor27};
    height: 38px;
    font-size: 16px;
    line-height: normal;

    ::placeholder {
      color: ${({ theme }) => theme.cor70}!important;
    }
  }

  .mantine-InputWrapper-label {
    color: ${({ theme }) => theme.cor9} !important;
    font-size: ${({ fontSize }) => fontSize} !important;
    background-color: transparent !important;
  }

  .mantine-Input-input[data-invalid] {
    border: 0.0625rem solid ${({ theme }) => theme.inputBorderError} !important;
  }

  .mantine-TextInput-icon {
    color: ${({ theme }) => theme.cor9}!important;
  }
`

export const LabelWrapper = styled.div`
  display: flex;
  gap: 5px;
`

export const Required = styled.div`
  color: ${({ theme }) => theme.inputBorderError};
`
